module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_10-0d8d5e618ef960c6d582a27378b09275.jpg";